import { render, staticRenderFns } from "./div-btn.vue?vue&type=template&id=52c0adae&scoped=true"
import script from "./div-btn.vue?vue&type=script&lang=js"
export * from "./div-btn.vue?vue&type=script&lang=js"
import style0 from "./div-btn.vue?vue&type=style&index=0&id=52c0adae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c0adae",
  null
  
)

export default component.exports